export default "__VITE_ASSET__DJLEEGel__"